<template>
  <a :href="this.link" class="d-flex align-items-center mt-2 mb-2 contact-container" :style="{backgroundImage:createBackgroundString}">
    <div>
      <img class="contact-image" :src="require('../assets/' +image)">
    </div>
    <div class="text">{{ text }}</div>
  </a>
</template>

<script>
export default {
  name: "ContactSection",
  data(){
    return{
      firstProgress: 0
    }
  },
  props:{
    image:{
      type: String,
      default: "/"
    },
    text:{
      type: String,
      default: "Text"
    },
    bColor0:{
      type: String,
      default: "rgb(28,156,234,0.3)"
    },
    bColor1:{
      type: String,
      default: "rgb(28,156,234,0.3)"
    },
    bColor2:{
      type: String,
      default: "rgb(28,156,234,0)"
    },
    progress:{
      type: Number,
      default: 100
    },
    link:{
      type: String,
      default: '/'
    }
  },
  computed: {
    createBackgroundString() {
      return `linear-gradient(90deg,${this.bColor0} 0%, ${this.bColor0} 50%, ${this.bColor1} 50%, ${this.bColor2} ${this.progress}%)`;
    }
  },
  // methods:{
  //   setProgress(p){
  //     this.firstProgress = p;
  //     console.log("coucou")
  //   },
  //   test(hover){
  //     if(hover){
  //       this.setProgress(this.firstProgress + 1)
  //     }
  //     else{
  //       if(this.firstProgress > 0)
  //       this.setProgress(this.firstProgress - 1)
  //     }
  //   }
  // }
}
</script>

<style lang="scss" scoped>

@import "~bootstrap/scss/functions";
@import "~bootstrap/scss/variables";
@import "~bootstrap/scss/mixins";

.contact-container{
  background-image: linear-gradient(#5187c4, #1c2f45);
  border-radius: 15px;
  background-size: 200% auto;
  background-position: right;
  transition: background-position 0.5s;
}
.contact-container:hover{
  background-position: left;
}

.contact-image{
  height: 45px;
  width: 45px;
  padding: 5px;

  @include media-breakpoint-up(sm) {
    height: 60px;
    width: 60px;
  }
}

a{
  text-decoration: none;
  color: black;
}

.text{
  font-size: 1rem;
  margin-left: 10px;
  text-decoration: none;

  @include media-breakpoint-up(sm) {
    font-size: 1.3rem;
    margin-left: 10px;
  }

  @include media-breakpoint-up(md) {
    font-size: 1.5rem;
    margin-left: 20px;
  }
}

</style>